"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveAgeGroupCommand = void 0;
const ddd_library_1 = require("@hoepel.app/ddd-library");
class RemoveAgeGroupCommand extends ddd_library_1.CommandBase {
    constructor() {
        super(...arguments);
        this.name = 'remove-age-group-command';
    }
    static create(ageGroupName, commandMetadata) {
        return new RemoveAgeGroupCommand({
            ageGroupName,
        }, commandMetadata);
    }
    get ageGroupName() {
        return this.payload.ageGroupName;
    }
}
exports.RemoveAgeGroupCommand = RemoveAgeGroupCommand;
//# sourceMappingURL=remove-age-group.command.js.map